import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface NotificationState {
  unreadCount: number;
  lastSyncedAt: string | null;
}

const initialState: NotificationState = {
  unreadCount: 0,
  lastSyncedAt: null,
};

const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setNotificationUnreadCount: (state, action: PayloadAction<number>) => {
      state.unreadCount = Math.max(0, action.payload);
      state.lastSyncedAt = new Date().toISOString();
    },
    clearNotificationState: (state) => {
      state.unreadCount = 0;
      state.lastSyncedAt = null;
    },
  },
});

export const {setNotificationUnreadCount, clearNotificationState} = notificationSlice.actions;
export default notificationSlice.reducer;
